import React from "react";

/**
 * Indicador de estado.
 * Props:
 *  - variant: "neutral" | "gold" | "success" | "warning" | "danger" | "info"
 *  - dot: muestra un punto de color antes del texto
 */
function Badge({ variant = "neutral", dot = false, className = "", children, ...rest }) {
  return (
    <span className={`sw-ui-badge sw-ui-badge--${variant} ${className}`} {...rest}>
      {dot && <span className="sw-ui-badge-dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

export default Badge;
